import ChiTietHoSoIgate from "interface/screens/hosotthc/chiTietHoSoIgate";
import React from "react";
import * as CONSTANTS from "../../../common/ulti/constants";

const CaNhanTongQuan = React.lazy(
  () => import("interface/screens/canhan/tongquan"),
);
const ThongTinCaNhan = React.lazy(
  () => import("interface/screens/canhan/thongtin"),
);
const XacThucSDT = React.lazy(
  () => import("interface/screens/canhan/xacthuc-sdt"),
);

const GoiYDichVu = React.lazy(() => import("interface/screens/canhan/dichvu"));

const MatKhau = React.lazy(() => import("interface/screens/canhan/matkhau"));

const KhoGiayToHub = React.lazy(
  () => import("interface/screens/canhan/khogiayto/index"),
);
const DanhSachKhoGiayTo = React.lazy(
  () => import("interface/screens/canhan/khogiayto/danhsach"),
);
const ChiTietKhoGiayTo = React.lazy(
  () => import("interface/screens/canhan/khogiayto/chitiet"),
);
const DownloadKhoGiayTo = React.lazy(
  () => import("interface/screens/canhan/khogiayto/download"),
);
const LienThongDuLieu = React.lazy(
  () => import("interface/screens/canhan/khogiayto/lienthong"),
);

const YeucauCapQuyen = React.lazy(
  () => import("interface/screens/canhan/khogiayto/yeucau"),
);
const LichSuTruyXuat = React.lazy(
  () => import("interface/screens/canhan/khogiayto/lichsu"),
);

const Page401 = React.lazy(() => import("interface/screens/error/401"));

const Page404 = React.lazy(() => import("interface/screens/error/404"));

const Page500 = React.lazy(() => import("interface/screens/error/500"));

//
const DanhSachHoSoTTHC = React.lazy(
  () => import("interface/screens/hosotthc/danhsach"),
);
const DanhSachChuDong = React.lazy(
  () => import("interface/screens/hosotthc/danhSachChuDong"),
);
const ChiTietHSKhaiSinh = React.lazy(
  () => import("interface/screens/hosotthc/chitietKhaiSinh"),
);
const ChiTietHSThuongTru = React.lazy(
  () => import("interface/screens/hosotthc/chitietThuongTru"),
);
const ChiTietHSNhapHoc = React.lazy(
  () => import("interface/screens/hosotthc/chitietNhapHoc"),
);
const ChiTietHSCapNuoc = React.lazy(
  () => import("interface/screens/hosotthc/chitietCapNuoc"),
);
const ChiTietHSCapDien = React.lazy(
  () => import("interface/screens/hosotthc/chitietCapDien"),
);
const HoSoMauTichHop = React.lazy(
  () => import("interface/screens/hosotthc/hoSoMauTichHop"),
);
const KiemThuTuDongHoa = React.lazy(
  () => import("interface/screens/hosotthc/kiemThuTuDongHoa"),
);
const KiemThuCapNhatTrangThai = React.lazy(
  () => import("interface/screens/hosotthc/kiemThuCapNhatTrangThai"),
);
const DanhSachThongBao = React.lazy(
  () => import("interface/screens/thongbao/danhsach"),
);
const NotificationHub = React.lazy(
  () => import("interface/screens/thongbao/hub/index"),
);
const ChiTietThongBao = React.lazy(
  () => import("interface/screens/thongbao/chitiet"),
);
const LichSuThongBao = React.lazy(
  () => import("interface/screens/thongbao/lichsudanhgia/lichsu"),
);
const LichSuPhanHoiThongBao = React.lazy(
  () => import("interface/screens/thongbao/lichsuphanhoi/index"),
);
const ConfigThongBao = React.lazy(
  () => import("interface/screens/thongbao/config/config"),
);
const LichHen = React.lazy(
  () => import("interface/screens/thongbao/lichhen/index"),
);
const LinkRedirect = React.lazy(
  () => import("interface/screens/home/linkredirect"),
);
const MobileNotifySimulator = React.lazy(
  () => import("interface/screens/home/MobileNotifySimulator"),
);
const GuiPhanAnh = React.lazy(() => import("interface/screens/phananh/gui"));
const DanhSachPhanAnh = React.lazy(
  () => import("interface/screens/phananh/danhsach"),
);
const DanhSachHoNgheoThongBao = React.lazy(
  () => import("interface/screens/thongbao/danhsachhongheo/index"),
);
const ThoiTiet = React.lazy(
  () => import("interface/screens/tienich/thoitiet/index"),
);
const WeatherTrendScreen = React.lazy(
  () => import("interface/screens/tienich/phantichthoitiet/index"),
);
const TinTucThoiTietScreen = React.lazy(
  () => import("interface/screens/tienich/tintucthoitiet/index"),
);

const dashboardRoutes = [
  {
    path: "/phan-anh",
    component: <GuiPhanAnh />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/phan-anh/lich-su",
    component: <DanhSachPhanAnh />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/ca-nhan",
    component: <CaNhanTongQuan />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/ca-nhan/thong-tin",
    component: <ThongTinCaNhan />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/ca-nhan/xac-thuc-sdt",
    component: <XacThucSDT />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/ca-nhan/dich-vu",
    component: <GoiYDichVu />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/mat-khau",
    component: <MatKhau />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to",
    component: <KhoGiayToHub />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/danh-sach",
    component: <DanhSachKhoGiayTo />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/sap-het-han",
    component: <DanhSachKhoGiayTo defaultExpiration="expiring" />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/het-han",
    component: <DanhSachKhoGiayTo defaultExpiration="expired" />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/lien-thong",
    component: <LienThongDuLieu />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/yeu-cau",
    component: <YeucauCapQuyen />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/lich-su",
    component: <LichSuTruyXuat />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/upload",
    component: <ChiTietKhoGiayTo />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/upload/:id",
    component: <ChiTietKhoGiayTo />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/kho-giay-to/download/:fileId",
    component: <DownloadKhoGiayTo />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/home",
    component: <DanhSachHoSoTTHC />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/tien-trinh-chu-dong",
    component: <DanhSachChuDong />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/thong-bao",
    component: <DanhSachThongBao />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/thong-bao-hub",
    component: <NotificationHub />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/thong-bao/lich-su",
    component: <LichSuPhanHoiThongBao />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/thong-bao/lich-su-phan-hoi",
    component: <LichSuPhanHoiThongBao />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/thong-bao/cai-dat",
    component: <ConfigThongBao />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/thong-bao/lich-hen",
    component: <LichHen />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/thong-bao/:id",
    component: <ChiTietThongBao />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/401",
    component: <Page401 />,
    roles: [],
  },
  {
    path: "/404",
    component: <Page404 />,
    roles: [],
  },
  {
    path: "/500",
    component: <Page500 />,
    roles: [],
  },

  {
    path: "/ho-so-mau",
    component: <HoSoMauTichHop />,
    roles: [],
  },
  {
    path: "/kiem-thu-tu-dong-hoa",
    component: <KiemThuTuDongHoa />,
    roles: [],
  },
  {
    path: "/kiem-thu-cap-nhat-trang-thai",
    component: <KiemThuCapNhatTrangThai />,
    roles: [],
  },
  {
    path: "/gia-lap-thong-bao-mobile",
    component: <MobileNotifySimulator />,
    roles: [],
  },
  {
    path: "/mobile-simulator",
    component: <MobileNotifySimulator />,
    roles: [],
  },
  {
    path: "/home/mobile-simulator",
    component: <MobileNotifySimulator />,
    roles: [],
  },
  {
    path: "/dang-ky-khai-sinh/:id",
    component: <ChiTietHSKhaiSinh />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/ho-so-thuong-tru/:id",
    component: <ChiTietHSThuongTru />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/dang-ky-nhap-hoc/:id",
    component: <ChiTietHSNhapHoc />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/dang-ky-cap-nuoc/:id",
    component: <ChiTietHSCapNuoc />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/dang-ky-cap-dien/:id",
    component: <ChiTietHSCapDien />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/nong-nghiep-moi-truong/danh-sach-ho-ngheo/:id",
    component: <DanhSachHoNgheoThongBao />,
    roles: [],
    // isUpdating: true,
  },
  // {
  //   path: "/:type/:id",
  //   component: <ChiTietHoSoIgate />,
  //   roles: [],
  //   // isUpdating: true,
  // },
  {
    path: "/:hash",
    component: <LinkRedirect />,
    roles: [],
    // isUpdating: true,
  },
  {
    path: "/thoi-tiet",
    component: <ThoiTiet />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/phan-tich-thoi-tiet",
    component: <WeatherTrendScreen />,
    roles: [],
    isUpdating: true,
  },
  {
    path: "/thu-thap-du-lieu-thoi-tiet",
    component: <TinTucThoiTietScreen />,
    roles: [],
    isUpdating: true,
  },
  { redirect: true, path: "*", to: "/home" },
];

export default dashboardRoutes;
